import FWDeviceSettingsPage from '../../../../customized/fresh-watch/components/Device/DeviceSettings/FWDeviceSettingsPage';
import { ToggleComponent } from '../../../../featureToggle';
import DeviceSettingsPage from './DeviceSettingsPage';

export default ToggleComponent(DeviceSettingsPage, {
  styledComponentsVariants: {
    'fresh-watch': FWDeviceSettingsPage,
  },
});
